import { render } from "./WeekdaySale.vue?vue&type=template&id=32de15f8&ts=true"
import script from "./WeekdaySale.vue?vue&type=script&lang=ts"
export * from "./WeekdaySale.vue?vue&type=script&lang=ts"

import "./WeekdaySale.vue?vue&type=style&index=0&id=32de15f8&lang=scss"

import exportComponent from "/home/issa/hcpet/hcpet-kasse/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__